export default __webpack_public_path__ + "static/media/1614234524180 (1) 1.28c169fe.png";